const Message = ({ title, children, className = '' }) => {
  return (
    <div className={`bg-gray-50 rounded-lg border border-gray-200 ${className}`}>
      {title && <div className="text-sm text-gray-600 px-4 py-2 bg-gray-100 rounded-t-lg">{title}</div>}
      <div className="text-base font-medium p-4">{children}</div>
    </div>
  );
};

export default Message;
